document.addEventListener("DOMContentLoaded", () => {
    const lastVisit = localStorage.getItem("lastVisit");
    const sixtyDaysInMillis = 60 * 24 * 60 * 60 * 1000;

    const gateBlock = document.querySelector(".gate");
    const body = document.body;

    const showGate = !lastVisit || (Date.now() - lastVisit > sixtyDaysInMillis);
    if ( gateBlock &&showGate) {
        gateBlock.classList.add("show");
        body.classList.add("gate-shown");
    }

    document.querySelectorAll(".gate__btns .btn, .gate__close").forEach(btn => {
        btn.addEventListener("click", (event) => {
            gateBlock.classList.remove("show");
            body.classList.remove("gate-shown");
            localStorage.setItem("lastVisit", Date.now());
        });
    });
});